<template>
  <modal :is-modal-show="isModalVisible" @close="closeModal">
    <template slot="header">
      {{ docType }}{{ docValue }} <br>
      <small>Preview scan/photo berkas yang diunggah Mahasiswa:</small>
    </template>
    <template slot="body">
      <div class="flex justify-center">
        <blob-image :src="imgUrl" />
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/Shared/Modal.vue'
import BlobImage from '@/Shared/BlobImage'
export default {
  components: {
    Modal,
    BlobImage,
  },
  props: {
    mahasiswa: Object,
    isModalVisible: {
      type: Boolean,
      default: false,
    },
    imgUrl: String,
    fieldName: String,
  },
  data () {
    return {
      docType: null,
      docValue: null,
    }
  },
  watch: {
    fieldName (newVal) {
      this.setHeaderInfo(newVal)
    },
  },
  methods: {
    closeModal () {
      this.$emit('close')
    },
    setHeaderInfo (fieldName) {
      switch (fieldName) {
      case 'nik_file':
        this.docType = 'Nomor KTP Mahasiswa: '
        this.docValue = this.mahasiswa.nik
        break
      case 'no_kk_file':
        this.docType = 'KK Mahasiswa: '
        this.docValue = this.mahasiswa.no_kk
        break
      case 'photo':
        this.docType = 'Photo 4x6 Mahasiswa'
        this.docValue = ''
        break
      case 'father_nik_file':
        this.docType = 'KTP Ayah: '
        this.docValue = this.mahasiswa.father_nik
        break
      case 'mother_nik_file':
        this.docType = 'KTP Ibu: '
        this.docValue = this.mahasiswa.mother_nik
        break
      case 'bank_acc_file':
        this.docType = 'Nomor Rekening Mahasiswa: '
        this.docValue = this.mahasiswa.bank_acc_number
        break
      case 'statement_doc_file':
        this.docType = 'Dokumen surat pernyataan'
        this.docValue = ''
        break
      case 'student_id_file':
        this.docType = 'KTM Mahasiswa: '
        this.docValue = this.mahasiswa.nim
        break
      default:
        this.docType = ''
        this.docValue = ''
        break
      }
    },
  },
}
</script>
